import {useEffect} from 'react';

export function useDragAutoScroll(active: boolean) {
    useEffect(() => {
        if (!active) {
            return;
        }

        const edgeSize = 72;
        const scrollSpeed = 18;
        let direction = 0;
        let frame = 0;

        function onDragOver(event: DragEvent) {
            if (event.clientY < edgeSize) {
                direction = -1;
            } else if (event.clientY > window.innerHeight - edgeSize) {
                direction = 1;
            } else {
                direction = 0;
            }
        }

        function onWheel(event: WheelEvent) {
            event.preventDefault();
            window.scrollBy(0, event.deltaY);
        }

        function tick() {
            if (direction !== 0) {
                window.scrollBy(0, direction * scrollSpeed);
            }
            frame = window.requestAnimationFrame(tick);
        }

        frame = window.requestAnimationFrame(tick);
        window.addEventListener('dragover', onDragOver);
        window.addEventListener('wheel', onWheel, {passive: false, capture: true});

        return () => {
            window.cancelAnimationFrame(frame);
            window.removeEventListener('dragover', onDragOver);
            window.removeEventListener('wheel', onWheel, {capture: true});
        };
    }, [active]);
}
